import ReactDOM from 'react-dom';
import * as Logger from '@crimson-education/browser-logger';
import config from './config';
import App from './App';

const isLocalhost = window.location.hostname === 'localhost';
const sensitiveQueryKeys = new Set([
  'token',
  'access_token',
  'id_token',
  'refresh_token',
  'authorization',
  'auth',
  'jwt',
  'code',
  'state',
  'session_state',
  'samlrequest',
  'samlresponse',
]);

const sanitizeAnalyticsUrl = (rawUrl: string): string => {
  if (!rawUrl) {
    return rawUrl;
  }

  try {
    const url = new URL(rawUrl, window.location.origin);
    Array.from(url.searchParams.keys()).forEach((key) => {
      if (sensitiveQueryKeys.has(key.toLowerCase())) {
        url.searchParams.set(key, 'REDACTED');
      }
    });
    return url.toString();
  } catch {
    return rawUrl;
  }
};
Logger.init({
  service: 'roadmap-frontend',
  environment: config.environment,
  version: config.version,
  defaultMetadata: {
    application: 'core-progress',
  },
  reporters: {
    log: true,
    datadog: config.datadogApplicationId
      ? {
          applicationId: config.datadogApplicationId,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          clientToken: config.datadogClientToken!,
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          site: config.datadogSite!,
          proxyUrl: config.datadogTunnelProxyUrl,
          version: config.datadogVersion,

          sampleRate: config.environment === 'production' ? 100 : 0,
          replaySampleRate: 0,

          forwardConsoleLogs: false,
          logTransport: true,
          trackInteractions: !isLocalhost,
          trackFrustrations: !isLocalhost,
          allowedTracingUrls: [config.studentCenterAPIUrl, config.crimsonAppAPIUrl, config.roadMapAPIUrl],
        }
      : undefined,
    posthog:
      config.posthogApiKey && config.posthogApiHost
        ? {
            apiKey: config.posthogApiKey,
            apiHost: config.posthogApiHost,
            autocapture: false,
            capturePageview: 'history_change',
            replaySampleRate: 0,
            ignoreTrackEventPatterns: ['roadmap-app-ready'],
            beforeSend: (event) => {
              if (event?.properties) {
                ['$current_url', '$referrer', 'url'].forEach((key) => {
                  const value = event.properties?.[key];
                  if (typeof value === 'string') {
                    event.properties[key] = sanitizeAnalyticsUrl(value);
                  }
                });
              }
              return event;
            },
          }
        : undefined,
  },
});

if (config.datadogApplicationId) {
  console.debug('Roadmap Datadog enabled');
}

ReactDOM.render(<App />, document.getElementById('root'));
